import fetchTMApi from "@helper/fetchTMApi";
import { LatestVideoResponse } from "@transformer/useBrightcoveResponse";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { MoreArticlesRequestData } from "@typings/MoreArticlesApi";

// ---------------------------- API Calls ------------------------------
export async function getMoreVideos(
  offset: number,
): Promise<LatestVideoResponse[]> {
  return await fetchTMApi<LatestVideoResponse[]>(
    `latest-portrait-videos?offset=${offset}`,
    "GET",
  );
}

export async function getMoreFeeds(
  requestData: MoreArticlesRequestData,
  loadOlderArticles?: boolean,
): Promise<ProcessedArticleData[]> {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const queryParams = new URLSearchParams({
    sort: Array.isArray(requestData.sort) ? requestData.sort.join(",") : "",
    more: loadOlderArticles ? "older" : "today",
  }).toString();
  return await fetchTMApi<ProcessedArticleData[]>(
    `quick-news/get-articles?${queryParams}`,
    "GET",
  );
}

export async function getMoreGallery(
  requestData: MoreArticlesRequestData,
): Promise<ProcessedArticleData[]> {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const queryParams = new URLSearchParams({
    sort: Array.isArray(requestData.sort) ? requestData.sort.join(",") : "",
  }).toString();
  // HOTFIX: Temporary error handling for get-gallery 500s; return empty list on failure. BHTM-1435
  try {
    return await fetchTMApi<ProcessedArticleData[]>(
      `quick-news/get-gallery?${queryParams}`,
      "GET",
    );
  } catch (err) {
    console.warn("get-gallery failed:", err);
    return [];
  }
}
